import axios from 'axios';

// Determine base URL based on environment
const getBaseURL = () => {
  // Check if we're in development (localhost)
  const isLocal = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || 
     window.location.hostname === '127.0.0.1' ||
     window.location.hostname === '0.0.0.0');
  
  // Use environment variable if set, otherwise use localhost:3001 for dev
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In development, use backend server directly
  if (isLocal) {
    return 'http://localhost:3001';
  }
  
  // In production, use relative URL (proxy will handle it)
  return '/';
};

const api = axios.create({
  baseURL: getBaseURL(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      const msg = error?.response?.data?.message || '';
      if (msg.includes('demo session') || msg.includes('Session Expired')) {
        window.dispatchEvent(new CustomEvent('auth:session-expired'));
      }
      console.warn('Unauthorized. Token may be invalid/expired.');
    }
    return Promise.reject(error);
  }
);

export default api;



